import type { AchievementBackgroundProps } from '../Achievement';

export const NeutralBackground = ({ size }: AchievementBackgroundProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 164 164"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M68.3538 12.1727C76.1293 5.23681 87.8707 5.23679 95.6462 12.1727L116.613 30.8753C117.634 31.7864 118.744 32.593 119.927 33.2829L144.193 47.4439C153.192 52.6955 156.82 63.8622 152.627 73.4005L141.318 99.1203C140.768 100.373 140.343 101.678 140.053 103.016L134.083 130.47C131.87 140.652 122.371 147.553 112.003 146.513L84.048 143.706C82.6861 143.569 81.3139 143.569 79.952 143.706L51.9966 146.513C41.6292 147.553 32.1302 140.652 29.9165 130.47L23.9473 103.016C23.6565 101.678 23.2325 100.373 22.6816 99.1203L11.3734 73.4005C7.17971 63.8623 10.808 52.6955 19.8072 47.4439L44.0735 33.2829C45.2556 32.593 46.3658 31.7864 47.3872 30.8753L68.3538 12.1727Z"
      fill="none"
      stroke="white"
      strokeWidth={16}
      strokeLinejoin="round"
    />
    <path
      d="M68.3538 12.1727C76.1293 5.23681 87.8707 5.23679 95.6462 12.1727L116.613 30.8753C117.634 31.7864 118.744 32.593 119.927 33.2829L144.193 47.4439C153.192 52.6955 156.82 63.8622 152.627 73.4005L141.318 99.1203C140.768 100.373 140.343 101.678 140.053 103.016L134.083 130.47C131.87 140.652 122.371 147.553 112.003 146.513L84.048 143.706C82.6861 143.569 81.3139 143.569 79.952 143.706L51.9966 146.513C41.6292 147.553 32.1302 140.652 29.9165 130.47L23.9473 103.016C23.6565 101.678 23.2325 100.373 22.6816 99.1203L11.3734 73.4005C7.17971 63.8623 10.808 52.6955 19.8072 47.4439L44.0735 33.2829C45.2556 32.593 46.3658 31.7864 47.3872 30.8753L68.3538 12.1727Z"
      fill="#3391B9"
    />
  </svg>
);
